import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Button } from '@/components/Button';
import { Flex } from '@/components/Flex';
import type { LineProps } from '@/components/Summary';
import { Typography } from '@/components/Typography';
import { conditionalStyle, responsive } from '@/theme';

import type { SummaryProps } from './CheckoutSection';

import { ReactComponent as EditSvg } from '@/assets/edit.svg';

export const Container = styled(Box)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const Subheader = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    margin-bottom: ${theme.spacing(1)};
  `}
`;

export const Summary = styled(Flex)<Pick<SummaryProps, 'hasError'>>`
  flex-direction: column;
  position: relative;
  flex-grow: 1;

  ${({ hasError, theme }) => css`
    background-color: ${theme.colors.lightGrey};
    padding: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(2)};
    ${conditionalStyle(hasError, 'border', `1px solid ${theme.colors.error}`)}
  `}

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SummaryError = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const SummaryLine = styled(Typography)<Pick<LineProps, 'isBold'>>`
  line-height: 22px;

  ${({ isBold, theme }) => css`
    ${conditionalStyle(isBold, 'font-weight', theme.fontWeights.bold)}
  `}
`;

export const SummaryEdit = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: underline;
  padding: ${({ theme }) => theme.spacing(2)};
  cursor: pointer;
`;

export const ActonButton = styled(Button)`
  padding-inline: unset;

  ${responsive('width', '100%', '150px')}
`;

export const EditIcon = styled(EditSvg)`
  height: 22px;
`;

export const IconWrapper = styled(Box)`
  cursor: pointer;
`;
